<template>
  <div
    class="w-100"
    style="height:200px"
  >
    <div class="d-flex flex-wrap h-100">
      <div class="col-7 h-100 overflow-hidden">
        <div class="p-1 h-100 rounded border-default border segments">
          <div
            v-if="parsingItem"
            class="d-flex w-100 h-100 align-items-center justify-content-center"
          >
            <b-spinner variant="primary" />
          </div>
          <template v-else>
            <parsed-segment
              v-for="(segment,index) in filteredSegments"
              :key="`${segment.uri}-${index}-${item.uri}`"
              :segment="segment"
              :displaying-item-uri="displayingItem ? displayingItem.uri : null"
              @display="displayInfo"
            />
            <div
              v-if="segmentsToDisplay < segments.length"
              class="d-flex"
            >
              <a
                class="text-primary text-xsm"
                style="margin-right:5px"
                @click="showMore"
              >More</a>
              <a
                v-if="segmentsToDisplay > 5"
                class="text-secoondary text-xsm"
                @click="showLess"
              >Hide</a>
            </div>
          </template>
        </div>
      </div>
      <div class="col-5">
        <div class="p-1 rounded border-default border h-100 mh-100">
          <parsed-item-display :item-data="displayingItem" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ParsedSegment from '../parser-list/ParsedSegment.vue'
import ParsedItemDisplay from '../parser-list/ParsedItemDisplay.vue'
import m3u8ParserHelpers from '@/mixins/m3u8-parser-helpers'

export default {
  name: 'OutputItem',
  components: { ParsedSegment, ParsedItemDisplay },
  mixins: [m3u8ParserHelpers],
  props: {
    dir: {
      required: true,
      type: String,
    },
    item: {
      required: true,
      type: Object,
    },
    displayingItemUri: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      segmentsToDisplay: 5,
      parsing: false,
      parsedManifest: null,
      displayingItem: null,
      parsingItem: false,
    }
  },
  computed: {
    filteredSegments() {
      if (!this.parsedItemData) return []
      return this.segments.slice(0, this.segmentsToDisplay)
    },
    segments() {
      if (!this.parsedItemData) return []
      return this.parsedItemData.segments
    },
  },
  created() {
    this.displayingItem = this.item
    this.parseItemManifest()
  },
  methods: {
    showLess() {
      this.segmentsToDisplay = 5
    },
    showMore() {
      this.segmentsToDisplay += 5
    },
    displayInfo(data) {
      this.displayingItem = data
    },
    parseItemManifest() {
      this.parsingItem = true
      this.$emit('display', this.item)
      this.parseFromUrl(`${this.dir}/${this.item.uri}`).then(manifest => {
        this.parsedItemData = manifest
        this.displaySegments = true
      }).catch(err => this.errorToast(err)).finally(() => {
        this.parsingItem = false
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.segments {
  overflow: scroll;
}
</style>
